import React, { Component } from 'react';
import '../brochure.scss';
import { actions } from '../redux/brochureActions';
import styled from 'styled-components';
import { Nav, NavItem, Tab, Form } from 'react-bootstrap';

import General from '../components/BrokerApplicationFormTabs/General/General';
import Company from '../components/BrokerApplicationFormTabs/Company/Company';
import Account from '../components/BrokerApplicationFormTabs/Account/Account';
import Indemnity from '../components/BrokerApplicationFormTabs/Indemnity/Indemnity';
import Management from '../components/BrokerApplicationFormTabs/Management/Management';
import Regulation from '../components/BrokerApplicationFormTabs/Regulation/Regulation';
import Declaration from '../components/BrokerApplicationFormTabs/Declaration/Declaration';
import Complete from '../components/BrokerApplicationFormTabs/Complete/Complete';
import brokerSteps from '../../../helpers/brokerSteps';

import { getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import { change } from 'redux-form';
import {
  Box,
  BrochureSection,
  Content,
  BrokerApplicationNavigation,
  NavigationButton,
} from '../components/StyledComponents/StyledComponents';

const GENERAL = 1;
const COMPANY = 2;
const ACCOUNT = 3;
const INDEMNITY = 4;
const MANAGEMENT = 5;
const REGULATION = 6;
const DECLARATION = 7;
const COMPLETE = 8;

const nav = {
  General: GENERAL,
  Company: COMPANY,
  Account: ACCOUNT,
  'Professional Indemnity': INDEMNITY,
  Management: MANAGEMENT,
  Regulation: REGULATION,
  Declaration: DECLARATION,
  Complete: COMPLETE,
};

const components = {
  General: General,
  Company: Company,
  Account: Account,
  'Professional Indemnity': Indemnity,
  Management: Management,
  Regulation: Regulation,
  Declaration: Declaration,
  Complete: Complete,
};

const BrokerWizardBadge = styled.span`
    ${(props) =>
      props.isActive
        ? 'background-color: #21174F;' + 'color: white;' + 'border: none'
        : 'background-color: transparent;' +
          'border: 1px solid gray;' +
          'color: gray;' +
          'opacity: 0.4'};


    height: 40px;
    width: 40px;
    align-items: center;
    display: flex;
    justify-content: space-around;
    border-radius: 50%;
    margin-right: 15px;
    position: relative;
    -webkit-transition: .3s ease;
    transition: .3s ease;
    padding: 15px;
    left: 10px;
}


`;
const Breadcrumb = styled.div`
  padding-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const BreadcrumbItem = styled.div`
  display: flex;
`;

const Title = styled.span`
  font-size: 0.8em;
  color: #21174F;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.isActive ? '1' : '0.4')};
`;

const FORM_NAME = 'PublicBrokerApplicationForm';

class BrokerApplicationContainer extends Component {
  state = {
    activeTab: 1,
    blankFormUrl: '',
  };

  componentDidMount() {
    const { actions, change } = this.props;
    Promise.resolve(actions.getEmptyBrokerApplicationFormDocument()).then((url) => {
      this.setState({
        blankFormUrl: url,
      });
    });
    Promise.resolve(actions.getAdminBrokerRoleId()).then((id) =>
      change('data.attributes.users[0].role_id', id),
    );
  }

  removeDirectors = (from, to) => {
    const { array } = this.props;
    array.splice('data.attributes.metadata.directors', from, to);
  };

  handleTab = (key) => {
    const { activeTab } = this.state;
    if (activeTab !== COMPLETE) {
      this.setState({ activeTab: key });
    }
  };

  updateAddress = (address, fieldName) => {
    const { change } = this.props;
    change(fieldName, address);
  };

  nextPage = (values) => {
    const { actions } = this.props;
    const { activeTab } = this.state;
    if (activeTab === DECLARATION) {
      Promise.resolve(actions.savePublicBrokerApplication(values, true, true)).then(
        () => {
          this.setState({
            activeTab: activeTab + 1,
          });
        },
      );
    } else {
      this.setState({
        activeTab: activeTab + 1,
      });
    }
  };

  render() {
    const { activeTab } = this.state;
    const { handleSubmit, formValues, isSubmitting } = this.props;
    const { blankFormUrl } = this.state;

    return (
      <BrochureSection>
        <Tab.Container
          id={'brochure-broker-application'}
          // defaultActiveKey={activeTab}
          onSelect={this.handleTab}
          activeKey={activeTab}
        >
          <>
            <Breadcrumb>
              {Object.keys(nav).map((page) => {
                const eventKey = nav[page];
                return (
                  <Nav key={page}>
                    <NavItem eventKey={eventKey}>
                      <BreadcrumbItem>
                        <BrokerWizardBadge isActive={activeTab === eventKey}>
                          {eventKey}
                        </BrokerWizardBadge>
                        <Title isActive={activeTab === eventKey}>{page}</Title>
                      </BreadcrumbItem>
                    </NavItem>
                  </Nav>
                );
              })}
            </Breadcrumb>
            <div>
              <Form onSubmit={handleSubmit(this.nextPage)}>
                <Tab.Content animation unmountOnExit={true}>
                  {Object.keys(nav).map((page) => {
                    let BrokerFormComponent = components[page];
                    const brokerStep = nav[page] - 1;
                    return (
                      <Tab.Pane eventKey={nav[page]} key={page}>
                        <Content>
                          <Box>
                            <BrokerFormComponent
                              content={brokerSteps(brokerStep, false, true)}
                              form={FORM_NAME}
                              formValues={formValues}
                              updateAddress={this.updateAddress}
                              removeDirectors={this.removeDirectors}
                              blankFormUrl={blankFormUrl}
                            />
                            {activeTab !== COMPLETE && (
                              <BrokerApplicationNavigation>
                                <NavigationButton type="submit" disabled={isSubmitting}>
                                  {activeTab === DECLARATION ? 'Submit' : 'Next'}
                                </NavigationButton>
                                {activeTab > 1 && (
                                  <NavigationButton
                                    type="button"
                                    onClick={() => this.handleTab(activeTab - 1)}
                                  >
                                    Back
                                  </NavigationButton>
                                )}
                              </BrokerApplicationNavigation>
                            )}
                          </Box>
                        </Content>
                      </Tab.Pane>
                    );
                  })}
                </Tab.Content>
              </Form>
            </div>
          </>
        </Tab.Container>
      </BrochureSection>
    );
  }
}

export default compose(
  connect(
    (state) => ({
      isSubmitting: state.brochure.isSubmitting,
      formValues: getFormValues(FORM_NAME)(state),
      initialValues: {
        data: {
          attributes: {
            metadata: {
              broker_channel: 'jtc-b2b',
              business_type: 'insurance_broker',
            },
          },
        },
      },
    }),
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
      change: bindActionCreators(change, dispatch),
    }),
  ),
  reduxForm({ form: FORM_NAME }),
)(BrokerApplicationContainer);
